$shm_hitalama_map_overlayed $shm_hitalama_map_page
	camera_locked true
	overlayed true
	auto /
		^
		<= pointerdown_listener $shm_listener /
			\pointerdown
			<= pointerdown_handler null
		<= pointermove_listener $shm_listener /
			\pointermove
			<= pointermove_handler null
